import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../store/root-reducer';
// import { getFieldsRequest } from './extra-actions';
import {
  getFieldsRequest,
  getSingleProspectDetailsRequest,
  getSingleProspectSequencesDetailsRequest,
  unsubscribeProspectRequest,
  addToStepRequest,
  removeProspectRequest,
  singleProspectSequencesMarkAsRepliedRequest,
  singleProspectRemoveFromSequencesRequest,
  saveContactAttributesRequest,
  singleProspectSequencesMarkAsFinishedRequest,
  changePrimaryEmailInProspectRequest,
  deleteSecondaryEmailRequest,
  deleteSecondaryPhoneRequest,
  getTagsRequest,
  addTagsToProspectsRequest,
  updatePrimaryNumberRequest,
} from './extra-actions';
import {
  resetProspectDeleteEmailRequestStatus,
  resetProspectDeletePhoneRequestStatus,
  resetRemoveProspectRequest,
  resetSaveContactAttributesRequestStatus,
  resetSequenceAndStepData,
  resetProspectPrimaryEmailChangeRequestStatus,
  resetTags,
  resetUpdatePrimaryNumberState,
  resetBulkRequests,
  resetUnsubscribeRequestState,
  setProspectDetails,
  resetProspectFiltersFieldsAttributesValue,
  setActiveViewId,
  setCurrentViewType,
  setProspectToNavigateFromModal,
  setShowProspectDetailModal,
} from './prospect-slice';
import { ViewType } from './enums/prospect';
import Prospect from './prospect';

const mapStateToProps = (state: RootState) => ({
  fields: state.prospect.fields,
  getFieldsRequestStatus: state.prospect.getFieldsRequest.status,
  // ProspectDetails modal related state
  addToStepRequestStatus: state.prospect.addToStepRequest.status,
  addToStepRequestError: state.prospect.addToStepRequest.error,
  addToStepRequestMessage: state.prospect.addToStepRequest.message,
  addToStepRequestFailedCount:
    state.prospect.addToStepRequestResultCount.failed,
  addToStepRequestSuccessfulCount:
    state.prospect.addToStepRequestResultCount.successful,
  removeProspectStatus: state.prospect.removeProspectRequest.status,
  removeProspectError: state.prospect.removeProspectRequest.error,
  removeProspectMessage: state.prospect.removeProspectRequest.message,
  unsubscribeProspectStatus: state.prospect.unsubscribeProspectRequest.status,
  unsubscribeProspectError: state.prospect.unsubscribeProspectRequest.error,
  unsubscribeProspectMessage: state.prospect.unsubscribeProspectRequest.message,
  markAsRepliedError:
    state.prospect.singleProspectSequencesMarkAsRepliedRequest.error,
  markAsRepliedMessage:
    state.prospect.singleProspectSequencesMarkAsRepliedRequest.message,
  markAsRepliedStatus:
    state.prospect.singleProspectSequencesMarkAsRepliedRequest.status,
  markAsFinishedError:
    state.prospect.singleProspectSequencesMarkAsFinishedRequest.error,
  markAsFinishedMessage:
    state.prospect.singleProspectSequencesMarkAsFinishedRequest.message,
  markAsFinishedStatus:
    state.prospect.singleProspectSequencesMarkAsFinishedRequest.status,
  removeFromSequenceStatus:
    state.prospect.singleProspectRemoveFromSequencesRequest.status,
  removeFromSequenceError:
    state.prospect.singleProspectRemoveFromSequencesRequest.error,
  removeFromSequenceMessage:
    state.prospect.singleProspectRemoveFromSequencesRequest.message,
  deleteSecondaryEmailRequestStatus:
    state.prospect.deleteSecondaryEmailRequest.status,
  deleteSecondaryEmailRequestError:
    state.prospect.deleteSecondaryEmailRequest.error,
  deleteSecondaryEmailRequestMessage:
    state.prospect.deleteSecondaryEmailRequest.message,
  deleteSecondaryPhoneRequestStatus:
    state.prospect.deleteSecondaryPhoneRequest.status,
  deleteSecondaryPhoneRequestError:
    state.prospect.deleteSecondaryPhoneRequest.error,
  deleteSecondaryPhoneRequestMessage:
    state.prospect.deleteSecondaryPhoneRequest.message,
  primaryEmailChangeRequestStatus:
    state.prospect.changePrimaryEmailInProspectRequest.status,
  primaryEmailChangeRequestError:
    state.prospect.changePrimaryEmailInProspectRequest.error,
  primaryEmailChangeRequestMessage:
    state.prospect.changePrimaryEmailInProspectRequest.message,
  primaryPhoneChangeRequestStatus:
    state.prospect.updatePrimaryNumberRequest.status,
  primaryPhoneChangeRequestError:
    state.prospect.updatePrimaryNumberRequest.error,
  primaryPhoneChangeRequestMessage:
    state.prospect.updatePrimaryNumberRequest.message,
  saveContactAttributesRequestStatus:
    state.prospect.saveContactAttributesRequest.status,
  saveContactAttributesRequestError:
    state.prospect.saveContactAttributesRequest.error,
  saveContactAttributesRequestMessage:
    state.prospect.saveContactAttributesRequest.message,
  getSingleProspectSequencesDetailsStatus:
    state.prospect.getSingleProspectSequencesDetailsRequest.status,
  getSingleProspectDetailsStatus:
    state.prospect.getSingleProspectDetailsRequest.status,
  singleProspectData: state.prospect.singleProspect,
  singleProspectSequenceDetails: state.prospect.singleProspectSequenceDetails,
  allOutcomes: state.customOutcome.outcomes,
  tags: state.prospect.tags,
  addTagsToProspectsRequestStatus:
    state.prospect.addTagsToProspectsRequest.status,
  getSingleProspect: state?.prospect?.getSingleProspect,
  addToStepRequestReportData:
    state.prospect.addToStepRequestResultCount.resultData,
  filters: state.prospect.filters,
  sendUnsubscribeBulkProspectsRequestStatus:
    state.prospect.unsubscribeBulkProspectRequest.status,
  sendUnsubscribeBulkProspectsRequestError:
    state.prospect.unsubscribeBulkProspectRequest.error,
  sendUnsubscribeBulkProspectsRequestMessage:
    state.prospect.unsubscribeBulkProspectRequest.message,
  updateProspectFiltersViewRequestStatus:
    state.prospect.updateProspectFiltersViewRequest.status,
});

const mapDispatchToProps = {
  sendGetFieldsRequest: () => getFieldsRequest({}),
  // ProspectDetails modal related actions
  sendAddContactToStepRequest: (payload: any) => addToStepRequest(payload),
  resetSequenceAndStepData: () => resetSequenceAndStepData(),
  sendRemoveProspectRequest: (contactArr: number[]) =>
    removeProspectRequest(contactArr),
  sendUnsubscribeProspectRequest: (contactArr: number[]) =>
    unsubscribeProspectRequest(contactArr),
  sendGetSingleProspectSequencesDetailsRequest: (contactArr: number) =>
    getSingleProspectSequencesDetailsRequest(contactArr),
  sendSequenceMarkAsRepliedRequest: (contactAndStepIds: any[]) =>
    singleProspectSequencesMarkAsRepliedRequest(contactAndStepIds),
  sendSequenceMarkAsFinishedRequest: (contactAndStepIds: any[]) =>
    singleProspectSequencesMarkAsFinishedRequest(contactAndStepIds),
  sendSingleProspectRemoveFromSequencesRequest: (param: any) =>
    singleProspectRemoveFromSequencesRequest(param),
  sendSaveContactAttributesRequest: (contactId: number, attributes: []) =>
    saveContactAttributesRequest({ contactId, attributes }),
  sendGetSingleProspectDetailsRequest: (contactId: number) =>
    getSingleProspectDetailsRequest(contactId),
  resetRemoveProspectRequest: () => resetRemoveProspectRequest(),
  resetSaveContactAttributesRequestStatus: () =>
    resetSaveContactAttributesRequestStatus(),
  sendPrimaryEmailChangeInProspectRequest: (
    primaryEmailProspectInfoId: number,
    contactId: number,
  ) =>
    changePrimaryEmailInProspectRequest({
      primaryEmailProspectInfoId,
      contactId,
    }),
  sendPrimaryPhoneChangeInProspectRequest: (
    primaryPhoneProspectInfoId: number,
    contactId: number,
  ) =>
    updatePrimaryNumberRequest({
      primaryPhoneProspectInfoId,
      contactId,
    }),
  resetUpdatePrimaryNumberState: () => resetUpdatePrimaryNumberState(),
  sendDeleteEmailFromProspectRequest: (
    prospectInfoId: number,
    contactId: number,
  ) => deleteSecondaryEmailRequest({ prospectInfoId, contactId }),
  sendDeletePhoneFromProspectRequest: (
    prospectInfoId: number,
    contactId: number,
  ) => deleteSecondaryPhoneRequest({ prospectInfoId, contactId }),
  resetProspectDeleteEmailRequestStatus: () =>
    resetProspectDeleteEmailRequestStatus(),
  resetProspectDeletePhoneRequestStatus: () =>
    resetProspectDeletePhoneRequestStatus(),
  resetProspectPrimaryEmailChangeRequestStatus: () =>
    resetProspectPrimaryEmailChangeRequestStatus(),
  sendGetTagsRequest: () => getTagsRequest(),
  sendAddTagsToProspectsRequest: (payload: any) =>
    addTagsToProspectsRequest(payload),
  resetTags: () => resetTags(),
  setProspectDetails: (contactId: number) => setProspectDetails(contactId),
  resetProspectFiltersFieldsAttributesValue: (payload: any) =>
    resetProspectFiltersFieldsAttributesValue(payload),
  resetBulkRequests: () => resetBulkRequests(),
  resetUnsubscribeRequestState: () => resetUnsubscribeRequestState(),
  setActiveViewIdValue: (viewId: number | null) => setActiveViewId(viewId),
  setCurrentViewTypeValue: (viewType: ViewType) => setCurrentViewType(viewType),
  setProspectToNavigateFromModal: (payload: {
    ids: number[];
    columnName: string;
  }) => setProspectToNavigateFromModal(payload),
  setShowProspectDetailModal: (payload: boolean) =>
    setShowProspectDetailModal(payload),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector>;

export default connector(Prospect);
